import React, { Component } from 'react';
import { Link } from "react-router-dom";

import config from "./../config";

class GreinView extends Component {
	constructor(props) {
		super(props);

		this.url = config.apiRoot+'/api/greinar/';

		this.state = {};
	}

	componentDidMount() {
		if (this.props.match && this.props.match.params.grein_id) {
			this.fetchData();
		}
	}

	componentDidUpdate(prevProps, prevState) {
		if (this.props.match && this.props.match.params.grein_id && prevProps.match.params.grein_id != this.props.match.params.grein_id) {
			this.fetchData();
		}
	}

	fetchData() {
		fetch(this.url+this.props.match.params.grein_id)
			.then(function(response) {
				return response.json();
			})
			.then(function(json) {
				this.setState({
					data: json
				})
			}.bind(this));
	}

	render() {
		var dataItem = this.state.data || this.props.data || null;

		return (
			<React.Fragment>
				{
					dataItem &&
					<React.Fragment>

					<table>
					
						<tbody>
							<tr>
								<td><h3 style={{textAlign: 'left'}}>{dataItem.name}</h3></td>
							</tr>

							{
								dataItem.employer &&
								<tr>
									<td style={{textAlign: 'left'}}><strong>Employer</strong>:<br/>{dataItem.employer}</td>
								</tr>
							}

							{
								dataItem.position &&
								<tr>
									<td style={{textAlign: 'left'}}><strong>Position</strong>:<br/>{dataItem.position}</td>
								</tr>
							}

							{
								dataItem.address &&
								<tr>
									<td style={{textAlign: 'left'}}><strong>Address</strong>:<br/>{dataItem.address}</td>
								</tr>
							}

							{
								dataItem.country &&
								<tr>
									<td style={{textAlign: 'left'}}><strong>Country</strong>:<br/>{dataItem.country}</td>
								</tr>
							}

							{
								dataItem.email &&
								<tr>
									<td style={{textAlign: 'left'}}><strong>E-mail</strong>:<br/>{dataItem.email}</td>
								</tr>
							}
		
							{
								dataItem.major_field &&
								<tr>
									<td style={{textAlign: 'left'}}><strong>Major field of study</strong>:<br/>{dataItem.major_field}</td>
								</tr>
							}

							{
								dataItem.research_interest &&
								<tr>
									<td style={{textAlign: 'left'}}><strong>Area(s) of research interest</strong>:<br/>{dataItem.research_interest}</td>
								</tr>
							}

							{
								dataItem.teaching_interest &&
								<tr>
									<td style={{textAlign: 'left'}}><strong>Area(s) of teaching interest</strong>:<br/>{dataItem.teaching_interest}</td>
								</tr>
							}
						</tbody>

					</table>

					<br/><br/>

					</React.Fragment>
				}
			</React.Fragment>
		);
	}
}

export default GreinView;
